import { useTheme } from "../../../../../hooks";
import { type IFile } from "../../../../../interfaces";
import AttachmentLink from "../AttachmentLink";

interface Props {
  row: IFile;
}

const AttachmentsRow = ({ row: file }: Props) => {
  const theme = useTheme() as any;
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        minWidth: "200px",
        border: `1px solid ${theme.colors.thBackgroundColor[0]}`,
        padding: "10px",
      }}
      className="attachment">
      <AttachmentLink {...file} />
      <p
        style={{
          opacity: "0.6",
          fontSize: "12px",
          textAlign: "center",
          marginLeft: "5px",
        }}>
        {file.date}
      </p>
    </div>
  );
};
export default AttachmentsRow;
